import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";

import { useParams } from "react-router-dom";
import GoBack from "../../../component/molecules/goBack";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import Checkbox from "../../../component/atoms/input/checkbox";
import PretendardText from "./../../../component/atoms/text/pretendardText";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import MemberApi from "../../../api/member.api";
import { errorHandler } from "../../../util/errorHandler";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import { cMembershipList } from "../../../constants/userInfoConstants";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import moment from "moment";
import { route } from "../../../router/route";

const UserMembershipInfoDetail = () => {
  let { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_membership_info)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUserInfoFunc = async () => {
    try {
      const response = (await MemberApi.getDetail(id)).data.data.content;

      setUserInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const joinTypeFunc = () => {
    const flags = [
      userInfo?.normalJoinFlag ? "일반" : "",
      userInfo?.kakaoFlag ? "카카오" : "",
      userInfo?.naverFlag ? "네이버" : "",
    ];

    // 빈 문자열을 제거하고 합침
    const result = flags.filter((flag) => flag).join(" / ");

    return result;
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority && (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                <GrayBtn
                  onClick={() => {
                    setAlarmPopupOpen(true);
                  }}
                >
                  알림 보내기
                </GrayBtn>
                <GrayBtn
                  onClick={() => {
                    setSMSPopupOpen(true);
                  }}
                >
                  SMS 보내기
                </GrayBtn>
              </div>
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                회원 상세 내역
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 이름 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name}</DetailFormText>
                </DetailPageForm>
                {/* 아이디(이메일) */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    아이디(이메일)
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email}</DetailFormText>
                </DetailPageForm>
                {/* 닉네임 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    닉네임
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.nickname}</DetailFormText>
                </DetailPageForm>
                {/* 회원등급/레벨 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    회원등급/레벨
                  </DetailFormTitle>
                  <DetailFormText>
                    {" "}
                    {cMembershipList[userInfo?.membership]}/Lv.
                    {userInfo?.writingLevel}
                  </DetailFormText>
                </DetailPageForm>
                {/* 누적구매 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    누적구매
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.purchaseCount}회/
                    {formatNumberWithCommas(userInfo?.purchaseAmount)}원
                  </DetailFormText>
                </DetailPageForm>
                {/* 보유포인트 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    보유포인트
                  </DetailFormTitle>
                  <DetailFormText>
                    {Number(userInfo?.totalPoint).toLocaleString()}P
                  </DetailFormText>
                </DetailPageForm>
                {/* 가입연동 아이디 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    가입연동 아이디
                  </DetailFormTitle>
                  <DetailFormText>{joinTypeFunc()}</DetailFormText>
                </DetailPageForm>
                {/* 핸드폰 번호 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    핸드폰 번호
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.phoneNumber.replace(
                      /(\d{3})(\d{4})(\d{4})/,
                      "$1-$2-$3"
                    )}
                  </DetailFormText>
                </DetailPageForm>
                {/* 멤버십 상품 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    멤버십 상품
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.membership === 2
                      ? "월간 수강권"
                      : userInfo?.membership === 3
                      ? "일년 수강권"
                      : "평생 수강권"}
                  </DetailFormText>
                </DetailPageForm>
                {/* 멤버십 구매일 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    멤버십 구매일
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.membershipPurchaseDate
                      ? moment(userInfo?.membershipPurchaseDate).format(
                          "YYYY-MM-DD"
                        )
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 마지막 접속 날짜 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    마지막 접속 날짜
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.lastLoginDate
                      ? moment(userInfo?.lastLoginDate).format("YYYY-MM-DD")
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 약관 동의 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                    border: "none",
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    약관 동의
                  </DetailFormTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Checkbox
                      checked={userInfo?.receiveAgreement}
                      onChange={() => {}}
                    />
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: "21px",
                        color: "#999",
                      }}
                    >
                      혜택 및 이벤트 등 서비스 알림 수신에 동의합니다(선택)
                    </PretendardText>
                  </div>
                </DetailPageForm>
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}
    </>
  );
};

export default UserMembershipInfoDetail;
